import { Table as UDSTable } from '@telus-uds/components-web'

type Align = 'left' | 'center' | 'right'

type TableRowProps = {
  cells: TableCellProps[]
  rowCellAlign?: Align
}

type TableCellProps = {
  content: JSX.Element[]
  cellAlign?: Align
}

export type TableProps = {
  header: TableRowProps
  body: TableRowProps[]
  tableCellAlign?: Align
  compact?: boolean
}

const mapCells = (cells: TableCellProps[], align: Align) =>
  cells?.map((cell, i) => (
    <UDSTable.Cell align={cell.cellAlign ?? align} key={i}>
      {cell?.content}
    </UDSTable.Cell>
  ))

const Table = ({ header, body, tableCellAlign, compact = false }: TableProps) => (
  <UDSTable data-testid="allium-table-testid" variant={{ spacing: compact ? 'compact' : undefined }}>
    <UDSTable.Header>{mapCells(header?.cells, header.rowCellAlign ?? tableCellAlign)}</UDSTable.Header>
    <UDSTable.Body>
      {body?.map((row, index) => (
        <UDSTable.Row key={index}>{mapCells(row.cells, row.rowCellAlign ?? tableCellAlign)}</UDSTable.Row>
      ))}
    </UDSTable.Body>
  </UDSTable>
)
export default Table
